import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/pages/home/Home'
import HomeTour from '@/views/pages/home/HomeTour'
import ZoomSetup from '@/views/pages/zoomSetup/ZoomSetup'
import Class from '@/views/pages/class/Class'
import MelonTV from '@/views/pages/melonTV/MelonTV'
import MelonTVVideo from '@/views/pages/melonTV/MelonTVVideo'
import Log from '@/views/pages/log/Log'
import Login from '@/views/pages/auth/Login'
import Page404 from '@/views/pages/error/Page404'
import ForgotPassword from '@/views/pages/auth/ForgotPassword'
import EmptyLayout from '@/views/layouts/EmptyLayout'
import EmptyWithLogoLayout from '@/views/layouts/EmptyWithLogoLayout'
import Page403 from '@/views/pages/error/Page403'
import Page500 from '@/views/pages/error/Page500'
// import SignUp from '@/views/pages/auth/SignUp'
import SignUpEmail from '@/views/pages/auth/SignUp/SignUpEmail'
import SignUpFormStep1 from '@/views/pages/auth/SignUp/SignUpFormStep1'
import SignUpFormStep2 from '@/views/pages/auth/SignUp/SignUpFormStep2'
import SignUpConfirm from '@/views/pages/auth/SignUp/SignUpConfirm'
import ChangePassword from '@/views/pages/auth/ChangePassword'
import store from '@/store'
import { getToken } from '@/helpers/auth'
import SignUpThanks from '@/views/pages/auth/SignUp/SignUpThanks'
import Information from '@/views/pages/information/Information'
import Introduction from '@/views/pages/introduction/Introduction'
import ChangeMail from '@/views/pages/change/mail/ChangeMail'
import ChangeMailThanks from '@/views/pages/change/mail/ChangeMailThanks'
import SendMail from '@/views/pages/change/mail/SendMail'
import ChangeNotification from '@/views/pages/change/notification/ChangeNotification'
import ChangeNotificationThanks from '@/views/pages/change/notification/ChangeNotificationThanks'
import Change from '@/views/pages/change/Change'
import ChangeAddress from '@/views/pages/change/address/ChangeAddress'
import ChangeAddressThanks from '@/views/pages/change/address/ChangeAddressThanks'
import ChangeEmail from '@/views/pages/change/email/ChangeEmail'
import ChangeEmailThanks from '@/views/pages/change/email/ChangeEmailThanks'
import ChangeName from '@/views/pages/change/name/ChangeName'
import ChangeNameThanks from '@/views/pages/change/name/ChangeNameThanks'
import ChangePasswordInfo from '@/views/pages/change/password/ChangePassword'
import ChangePasswordInfoThanks from '@/views/pages/change/password/ChangePasswordThanks'
import ChangeMemberShip from '@/views/pages/change/membership/ChangeMemberShip'
import ChangeTell from '@/views/pages/change/tell/ChangeTell'
import ChangeTellThanks from '@/views/pages/change/tell/ChangeTellThanks'
import Unsubscribe from '@/views/pages/change/unsubscribe/Unsubscribe'
import UnsubscribeThanks from '@/views/pages/change/unsubscribe/UnsubscribeThanks'
import Enquete from '@/views/pages/change/unsubscribe/enquete/Enquete'
import LogUpdateSP from '@/views/pages/log/components/LogUpdateSP'
import ChangeVisaThanks from '@/views/pages/change/visa/ChangeVisaThanks'
import SignUpEmailVerify from '@/views/pages/auth/SignUp/SignUpEmailVerify'
import userService from '@/services/userService'
import CreditError from '@/views/pages/error/CreditCard'
import MailError from '@/views/pages/error/MailAddress'
import Beginner from '@/views/pages/beginner/Beginner'
import ReRegisterThanks from '@/views/pages/auth/SignUp/ReRegisterThanks'
import RegisterEmail from '@/views/pages/auth/CorpRegister/RegisterEmail'
import RegisterStep1 from '@/views/pages/auth/CorpRegister/RegisterStep1'
import RegisterStep2 from '@/views/pages/auth/CorpRegister/RegisterStep2'
import RegisterStep3 from '@/views/pages/auth/CorpRegister/RegisterStep3'
import RegisterThanks from '@/views/pages/auth/CorpRegister/RegisterThanks'
import CampaignMemberRegisterStep3 from '@/views/pages/auth/TrialRegister/RegisterStep3'
import MindfulSurvey from '@/views/pages/survey/MindfulSurvey'
import MindfulSurveyThanks from '@/views/pages/survey/MindfulSurveyThanks'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      auth: true
    }
  },
  {
    path: '/index.html',
    name: 'Home',
    component: Home
  },
  {
    path: '/zoom-setup/',
    name: 'ZoomSetup',
    component: ZoomSetup,
    meta: {
      layout: EmptyLayout,
      auth: true
    }
  },
  {
    path: '/class',
    name: 'Class',
    component: Class,
    meta: {
      auth: true
    }
  },
  {
    path: '/melon-tv',
    name: 'MelonTV',
    component: MelonTV,
    meta: {
      auth: true
    }
  },
  {
    path: '/melon-video/:video_id',
    name: 'MelonTVVideo',
    component: MelonTVVideo,
    meta: {
      auth: true
    }
  },
  {
    path: '/log',
    name: 'Log',
    component: Log,
    meta: {
      auth: true
    }
  },
  {
    path: '/signin',
    name: 'Login',
    component: Login,
    meta: {
      layout: EmptyLayout,
      auth: false
    }
  },
  {
    path: '/member-register/',
    name: 'SignUpEmail',
    component: SignUpEmail,
    meta: {
      layout: EmptyLayout,
      auth: false
    }
  },
  {
    path: '/member-register-email-verify/',
    name: 'SignUpEmailVerify',
    component: SignUpEmailVerify,
    meta: {
      layout: EmptyWithLogoLayout,
      auth: false
    }
  },
  {
    path: '/member-register/step-1',
    name: 'SignUpFormStep1',
    component: SignUpFormStep1,
    meta: {
      layout: EmptyLayout,
      auth: false
    }
  },
  {
    path: '/member-register/step-2',
    name: 'SignUpFormStep2',
    component: SignUpFormStep2,
    meta: {
      layout: EmptyLayout,
      auth: false
    }
  },
  {
    path: '/member-register/step-3',
    name: 'SignUpConfirm',
    component: SignUpConfirm,
    meta: {
      layout: EmptyLayout,
      auth: false
    }
  },
  {
    path: '/member-register/confirm-subscription/thanks',
    name: 'SignUpThanks',
    component: SignUpThanks,
    meta: {
      layout: EmptyLayout,
      auth: false
    }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: {
      layout: EmptyWithLogoLayout,
      auth: false
    }
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: {
      layout: EmptyWithLogoLayout,
      auth: false
    }
  },
  {
    path: '/mindful-survey',
    name: 'MindfulSurvey',
    component: MindfulSurvey,
    meta: {
      layout: EmptyWithLogoLayout
    }
  },
  {
    path: '/mindful-survey/company',
    name: 'MindfulSurveyCompany',
    component: MindfulSurvey,
    meta: {
      layout: EmptyWithLogoLayout
    }
  },
  {
    path: '/mindful-survey/thanks',
    name: 'MindfulSurveyThanks',
    component: MindfulSurveyThanks,
    meta: {
      layout: EmptyWithLogoLayout
    }
  },
  {
    path: '/introduction',
    name: 'Introduction',
    component: Introduction,
    meta: {
      auth: true
    }
  },
  {
    path: '/information',
    name: 'Information',
    component: Information
  },
  {
    path: '/change/',
    name: 'Change',
    component: Change,
    meta: {
      auth: true
    }
  },
  {
    path: '/change/address/',
    name: 'ChangeAddress',
    component: ChangeAddress,
    meta: {
      auth: true
    }
  },
  {
    path: '/change/address/thanks',
    name: 'ChangeAddressThanks',
    component: ChangeAddressThanks,
    meta: {
      auth: true
    }
  },
  {
    path: '/change/mail/',
    name: 'ChangeMail',
    component: ChangeMail,
    meta: {
      auth: true
    }
  },
  {
    path: '/change/mail/thanks',
    name: 'ChangeMailThanks',
    component: ChangeMailThanks,
    meta: {
      layout: EmptyLayout
    }
  },
  {
    path: '/change/mail/send',
    name: 'SendMail',
    component: SendMail,
    meta: {
      auth: true
    }
  },
  {
    path: '/change/notification/',
    name: 'ChangeNotification',
    component: ChangeNotification,
    meta: {
      auth: true
    }
  },
  {
    path: '/change/notification/thanks',
    name: 'ChangeNotificationThanks',
    component: ChangeNotificationThanks,
    meta: {
      auth: true
    }
  },
  {
    path: '/change/password',
    name: 'ChangePasswordInfo',
    component: ChangePasswordInfo,
    meta: {
      auth: true
    }
  },
  {
    path: '/change/password/thanks',
    name: 'ChangePasswordThanks',
    component: ChangePasswordInfoThanks,
    meta: {
      auth: true
    }
  },
  {
    path: '/change/e-mail',
    name: 'ChangeEmail',
    component: ChangeEmail,
    meta: {
      auth: true
    }
  },
  {
    path: '/change/e-mail/thanks',
    name: 'ChangeEmailThanks',
    component: ChangeEmailThanks,
    meta: {
      auth: true
    }
  },
  {
    path: '/change/name',
    name: 'ChangeName',
    component: ChangeName,
    meta: {
      auth: true
    }
  },
  {
    path: '/change/name/thanks',
    name: 'ChangeNameThanks',
    component: ChangeNameThanks,
    meta: {
      auth: true
    }
  },
  {
    path: '/change/membership',
    name: 'ChangeMemberShip',
    component: ChangeMemberShip,
    meta: {
      auth: true
    }
  },
  {
    path: '/change/tell',
    name: 'ChangeTell',
    component: ChangeTell,
    meta: {
      auth: true
    }
  },
  {
    path: '/change/tell/thanks',
    name: 'ChangeTellThanks',
    component: ChangeTellThanks,
    meta: {
      auth: true
    }
  },
  {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    component: Unsubscribe,
    meta: {
      auth: true
    }
  },
  {
    path: '/unsubscribe/thanks',
    name: 'UnsubscribeThanks',
    component: UnsubscribeThanks,
    meta: {
      auth: true
    }
  },
  {
    path: '/change/unsubscribe/enquete',
    name: 'Enquete',
    component: Enquete,
    meta: {
      auth: true
    }
  },
  {
    path: '/users/logout',
    name: 'Logout',
    component: Home
  },

  {
    path: '/403',
    name: 'Page403',
    component: Page403
  },
  {
    path: '/500',
    name: 'Page500',
    component: Page500
  },
  {
    path: '*',
    name: 'Page404',
    component: Page404
  },
  {
    path: '/log/update-record/:log_id',
    name: 'LogUpdateSP',
    component: LogUpdateSP,
    meta: {
      auth: true
    }
  },
  {
    path: '/change/visa/thanks',
    name: 'ChangeVisaThanks',
    component: ChangeVisaThanks,
    meta: {
      auth: true
    }
  },
  {
    path: '/error/credit-card',
    name: 'CreditCardError',
    component: CreditError,
    meta: {
      auth: true
    }
  },
  {
    path: '/error/mail-address',
    name: 'MailAddressError',
    component: MailError,
    meta: {
      auth: true
    }
  },
  {
    path: '/beginner',
    name: 'Beginner',
    component: Beginner,
    meta: {
      auth: true
    }
  },
  {
    path: '/member-register/confirm-re-register/thanks',
    name: 'ReRegisterThanks',
    component: ReRegisterThanks,
    meta: {
      layout: EmptyLayout,
      auth: false
    }
  },
  {
    path: '/corpwelfare-member-register',
    name: 'CorpRegisterEmail',
    component: RegisterEmail,
    meta: {
      layout: EmptyLayout,
      auth: false
    }
  },
  {
    path: '/corpwelfare-member-register/step-1',
    name: 'CorpRegisterStep1',
    component: RegisterStep1,
    meta: {
      layout: EmptyLayout,
      auth: false
    }
  },
  {
    path: '/corpwelfare-member-register/step-2',
    name: 'CorpRegisterStep2',
    component: RegisterStep2,
    meta: {
      layout: EmptyLayout,
      auth: false
    }
  },
  {
    path: '/corpwelfare-member-register/step-3',
    name: 'CorpRegisterStep3',
    component: RegisterStep3,
    meta: {
      layout: EmptyLayout,
      auth: false
    }
  },
  {
    path: '/corpwelfare-member-register/thanks',
    name: 'CorpRegisterThanks',
    component: RegisterThanks,
    meta: {
      layout: EmptyLayout,
      auth: false
    }
  },
  {
    path: '/gift-campaign-member-register',
    name: 'CampaignMemberRegisterEmail',
    component: SignUpEmail,
    meta: {
      layout: EmptyLayout,
      auth: false
    }
  },
  {
    path: '/gift-campaign-member-register/step-1',
    name: 'CampaignMemberRegisterStep1',
    component: SignUpFormStep1,
    meta: {
      layout: EmptyLayout,
      auth: false
    }
  },
  {
    path: '/gift-campaign-member-register/step-2',
    name: 'CampaignMemberRegisterStep2',
    component: SignUpFormStep2,
    meta: {
      layout: EmptyLayout,
      auth: false
    }
  },
  {
    path: '/gift-campaign-member-register/step-3',
    name: 'CampaignMemberRegisterStep3',
    component: CampaignMemberRegisterStep3,
    meta: {
      layout: EmptyLayout,
      auth: false
    }
  },
  {
    path: '/gift-campaign-member-register/thanks',
    name: 'CampaignMemberThanks',
    component: SignUpThanks,
    meta: {
      layout: EmptyLayout,
      auth: false
    }
  },
  {
    path: '/tutorial',
    name: 'Tutorial',
    component: HomeTour,
    meta: {
      auth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

function hasQueryParams(route) {
  if (route.query) {
    return Object.keys(route.query).length > 0
  }
  return false
}

router.beforeEach(async(toRoute, fromRoute, next) => {
  store.dispatch('layout/resetLayout', toRoute)
  let isLogin = store.state.user.isLogin
  if (toRoute.path === '/users/logout') {
    if (isLogin) {
      await userService.saveToken(null)
    }
    store.dispatch('user/logout')
    next('/signin')
  }
  if (!isLogin) {
    const hasToken = getToken()
    if (hasToken) {
      // is window reload, so we need authentication user
      isLogin = await store.dispatch('user/getInfo')
    }
  }

  if (toRoute.path !== '/') {
    store.dispatch('loading/updateLoading', false)
  }

  const isProtectRoute = toRoute.meta.auth
  if (toRoute.path === '/signin' || typeof isProtectRoute !== 'undefined') {
    if (!isProtectRoute && isLogin) {
      next(fromRoute.path)
    } else if (isProtectRoute && !isLogin) {
      const query = {}
      if (toRoute.path !== '/') {
        query.redirect = toRoute.fullPath
      }
      next({ path: '/signin', query: query })
    }
  }
  if (!hasQueryParams(toRoute) && hasQueryParams(fromRoute)) {
    next({ path: toRoute.path, query: fromRoute.query })
  }
  next()
})

export default router
